'use strict';

const { getDependencyClass } = require('../../../lib/dependencies.js');

module.exports = getDependencyClass('phoenix-page').then((pageClass) => {
    class PhoenixAccordionToggler extends pageClass.PhoenixElement {
        get observedBroadcastedEvents() {
            return ['phoenix:accordion:active'];
        }

        connectedCallback() {
            super.connectedCallback();
            this.waitForElement('button', { untilDomReady: true }).then((button) => {
                this.button = button;
                this.accordionId = this.getAttr('accordion-id', { required: true });
                this.itemId = this.getAttr('item-id', { required: true });
                this._expand = this.button.getAttribute('aria-expanded') === 'true';

                // TODO: add other keyboard events needed to make this more accessible
                this.listenEvents = ['click'];
                this._addListener();
            });
        }

        get expand() {
            return this._expand;
        }

        set expand(val) {
            this._expand = val;
            this.button.setAttribute('aria-expanded', val);
        }

        _addListener() {
            this.listenEvents.forEach((e) => {
                this.addEventListener(e, this.notify);
            });
        }

        _removeListener() {
            this.listenEvents.forEach((e) => {
                this.removeEventListener(e, this.notify);
            });
        }

        broadcastedEventCallback(name, args = {}) {
            const itemId = args.detail && args.detail.itemId;
            const accordionId = args.detail && args.detail.accordionId;

            if (accordionId !== this.accordionId) {
                return;
            }

            switch (name) {
                case 'phoenix:accordion:active':
                    this.expand = this.itemId === itemId;
                    break;
            }
        }

        notify() {
            const eventName = 'phoenix:accordion';
            this.emitEvent(eventName, {
                bubbles: true,
                detail: {
                    key: eventName,
                    itemId: this.expand ? '' : this.itemId,
                    accordionId: this.accordionId,
                },
            });
        }

        disconnectedCallback() {
            super.disconnectedCallback();
            this._removeListener();
        }
    }
    window.customElements.define('phoenix-accordion-toggler', PhoenixAccordionToggler);
});
